import React, { useState } from 'react';
import { Box, TextField, IconButton, Paper, Stack, Typography } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import TemplatesIcon from '@mui/icons-material/Category';
import Tooltip from '@mui/material/Tooltip';

const MessageInput = ({ onSendMessage, repliedMessage, onCancelReply }) => {
  const [message, setMessage] = useState('');

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSend();
    }
  };
  const handleSend = () => {
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
      onCancelReply();
    }
  };

  return (
    <Paper elevation={3} sx={{ borderRadius: '20px', position: 'relative', bottom: 0, width: '100%', padding: '20px', display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
      {repliedMessage && (
        <Box
          sx={{
            backgroundColor: '#f0f0f0',
            padding: '10px',
            borderRadius: '10px',
            width: '100%',
            mb: 1,
            display: 'flex',
            direction: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{padding: '0px 10px'}}>
            <Typography variant="caption" color="text.secondary">
              Reply to {repliedMessage.name}:
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {repliedMessage.message}
            </Typography>
          </div>
          <div>
            <IconButton size="small" onClick={onCancelReply}>
              ✕
            </IconButton>
          </div>
      </Box>
    )}
      <TextField
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth
          placeholder="Type your message..."
          sx={{ backgroundColor: 'white', borderRadius: '20px', marginBottom: '20px', width: '100%' }}
          onKeyDown={handleKeyDown}
      />
      <Stack direction="row" spacing={2} alignItems="center" sx={{width: '100%'}}>
        {/* <Tooltip title="Choose a template">
            <IconButton onClick={(e) => { }} sx={{backgroundColor: '#f5f5f5', borderRadius: '8px', width: '40px', height: '40px'}} >
                <TemplatesIcon />
            </IconButton>
        </Tooltip>
        <Tooltip title="Record audio">
            <IconButton onClick={(e) => { }} sx={{backgroundColor: '#f5f5f5', borderRadius: '8px', width: '40px', height: '40px'}} >
                <MicIcon />
            </IconButton>
        </Tooltip>
        <Tooltip title="Attach a file">
            <IconButton onClick={(e) => { }} sx={{backgroundColor: '#f5f5f5', borderRadius: '8px', width: '40px', height: '40px'}} >
                <AttachFileIcon />
            </IconButton>
        </Tooltip> */}
        <Box sx={{ flexGrow: 1 }} />
        <Tooltip title="Send message">
            <IconButton onClick={() => { handleSend(); }} sx={{ borderRadius: 30, backgroundColor: '#F8F9FA', padding: '5px 10px', color: "#29C0BB", cursor: 'pointer'}} >
                <SendIcon />
                <Typography variant="body2" sx={{ color: '#29C0BB', cursor: 'pointer', marginLeft: '5px', fontSize: '18px' }}>Send</Typography>
            </IconButton>
        </Tooltip>
      </Stack>
    </Paper>
  );
};

export default MessageInput;
